export default "__VITE_ASSET__e8545cb3__"